import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import ToolTip from '../Tooltip/Tooltip'

const EMPTY_ARRAY = []

const TabPanel = ({ tabs: tabsProp, background, onChangeTab, firstTab }) => {
    const tabs = tabsProp ?? EMPTY_ARRAY
    const [activeTab, setActiveTab] = useState(firstTab)
    const [hoveredTab, setHoveredTab] = useState(null)

    const handleTabClick = tab => {
        if (!tab.disabled) {
            setActiveTab(tab)
            if (tab?.key) {
                let url = new URL(window.location)
                url.searchParams.set('activeTab', tab?.key)
                window.history.pushState(null, '', url.toString())
            }
            if (onChangeTab) {
                onChangeTab(tab)
            }
        }
    }

    useEffect(() => {
        const getActiveIndex = tabs?.findIndex(
            tab => tab?.key === activeTab?.key,
        )
        setActiveTab(tabs[getActiveIndex])
    }, [tabs])

    return (
        <div className="w-full h-full flex-grow flex flex-col items-start justify-start">
            <div
                className={clsx(
                    'w-full h-auto flex flex-row items-end md:justify-start justify-around px-4 md:gap-8 gap-2',
                    background,
                    background && 'border-b border-grayLines',
                )}
            >
                {tabs.map((tab, index) => {
                    const isActive = tab?.key === activeTab?.key
                    return (
                        <div
                            key={`tab-${index}-${tab?.key}`}
                            className="relative inline-block"
                            onMouseEnter={() =>
                                setHoveredTab(tab.disabled ? tab : null)
                            }
                            onMouseLeave={() => setHoveredTab(null)}
                        >
                            <button
                                onClick={() => handleTabClick(tab)}
                                disabled={tab.disabled}
                                className={clsx(
                                    'md:text-base text-sm flex items-center justify-start transition-all font-normal text-textDarkerGray py-4 px-2 bg-transparent rounded-none',
                                    isActive && 'separated',
                                    tab.disabled &&
                                        'cursor-not-allowed text-gray-400',
                                )}
                            >
                                {tab?.title}
                                {tab?.count && (
                                    <p className="w-6 h-6 text-xs font-medium text-textDarkerGray rounded-full bg-grayBackground ml-2 flex items-center justify-center">
                                        {tab.count}
                                    </p>
                                )}
                            </button>
                            {hoveredTab === tab && tab.disabled && (
                                <ToolTip text="This feature requires an internet connection" />
                            )}
                        </div>
                    )
                })}
            </div>
            <div
                className={clsx(
                    'w-full flex-grow h-full transition-all',
                    activeTab?.hasPadding === false
                        ? 'lg:px-6 lg:py-4 px-0 py-0'
                        : 'lg:px-6 lg:py-4 px-4 py-4',
                )}
            >
                {activeTab?.content}
            </div>
        </div>
    )
}

TabPanel.propTypes = {
    tabs: PropTypes.arrayOf(
        PropTypes.shape({
            title: PropTypes.string,
            key: PropTypes.string,
            content: PropTypes.node,
            count: PropTypes.number,
            disabled: PropTypes.bool,
            disabledReason: PropTypes.string,
        }),
    ),
    firstTab: PropTypes.shape({
        key: PropTypes.string,
        active: PropTypes.bool,
    }),
    background: PropTypes.string,
    onChangeTab: PropTypes.oneOfType([PropTypes.func, PropTypes.any]),
}

export default TabPanel
